export default {"src":"/_next/static/media/lassie_loader.32400a55.gif","height":59,"width":64,"blurWidth":0,"blurHeight":0};